<template>
    <img src="/static/company/logo" style="margin: 16px 0; height: 50px" />
</template>

<script>
export default {
    inheritAttrs: false,

    computed: {
    },
}
</script>
